import { render } from "./UseIcon.vue?vue&type=template&id=041508a9&ts=true"
import script from "./UseIcon.vue?vue&type=script&lang=ts"
export * from "./UseIcon.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./UseIcon.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__